import requestAPI from './request-api';

export  default {
    requestAPI,
};